import { formatDateTime } from '../../../../../../../_metronic/helpers'
import { TFunction } from '../../../../../../../_metronic/i18n/Metronici18n'
import { EstudoDicom } from '../../../../atendimento/core/_models'

/** Modalidade e data do estudo, para nomes acessíveis e para o cabeçalho do visualizador. */
export const valoresDescricaoEstudo = (estudo: EstudoDicom, t: TFunction) => ({
  modalidade: estudo.modalidade ?? t('exames_imagem.sem_valor'),
  data: estudo.dataEstudo ? formatDateTime(estudo.dataEstudo) : t('exames_imagem.sem_valor'),
})
